import { ROLES, CONSTANTS } from 'config';
import { forIn } from 'lodash';

import template from './home.html';
import './home.styl';

function homeComponent($scope, $state, $filter, $mdDialog, $tszToast,
  uiGridConstants, AuthService, ReportService, ConfigService) {

  'ngInject';

  this.roles = ROLES;

  this.canSeeCuantitativeResults = AuthService.canSeeCuantitativeResults();

  this.getOpts = (c) => {
    const opts = [];
    forIn(c, (value, key) => {
      opts.push({
        value: key,
        label: value.name,
      });
    });
    return opts;
  };

  this.getVersionOpts = () => this.getOpts(CONSTANTS.VERSION);
  this.getDesignTypeOpts = () => this.getOpts(CONSTANTS.PROJECT_TYPE);
  this.getBuildingUsageOpts = () => this.getOpts(CONSTANTS.BUILDING_USAGE);

  const correctTotalPaginationTemplate = "<div role=\"contentinfo\" class=\"ui-grid-pager-panel\" ui-grid-pager ng-show=\"grid.options.enablePaginationControls\"><div role=\"navigation\" class=\"ui-grid-pager-container\"><div role=\"menubar\" class=\"ui-grid-pager-control\"><button type=\"button\" role=\"menuitem\" class=\"ui-grid-pager-first\" ui-grid-one-bind-title=\"aria.pageToFirst\" ui-grid-one-bind-aria-label=\"aria.pageToFirst\" ng-click=\"pageFirstPageClick()\" ng-disabled=\"cantPageBackward()\"><div class=\"first-triangle\"><div class=\"first-bar\"></div></div></button> <button type=\"button\" role=\"menuitem\" class=\"ui-grid-pager-previous\" ui-grid-one-bind-title=\"aria.pageBack\" ui-grid-one-bind-aria-label=\"aria.pageBack\" ng-click=\"pagePreviousPageClick()\" ng-disabled=\"cantPageBackward()\"><div class=\"first-triangle prev-triangle\"></div></button> <input type=\"number\" ui-grid-one-bind-title=\"aria.pageSelected\" ui-grid-one-bind-aria-label=\"aria.pageSelected\" class=\"ui-grid-pager-control-input\" ng-model=\"grid.options.paginationCurrentPage\" min=\"1\" max=\"{{ paginationApi.getTotalPages() }}\" required> <span class=\"ui-grid-pager-max-pages-number\" ng-show=\"paginationApi.getTotalPages() > 0\"><abbr ui-grid-one-bind-title=\"paginationOf\">/</abbr> {{ paginationApi.getTotalPages() }}</span> <button type=\"button\" role=\"menuitem\" class=\"ui-grid-pager-next\" ui-grid-one-bind-title=\"aria.pageForward\" ui-grid-one-bind-aria-label=\"aria.pageForward\" ng-click=\"pageNextPageClick()\" ng-disabled=\"cantPageForward()\"><div class=\"last-triangle next-triangle\"></div></button> <button type=\"button\" role=\"menuitem\" class=\"ui-grid-pager-last\" ui-grid-one-bind-title=\"aria.pageToLast\" ui-grid-one-bind-aria-label=\"aria.pageToLast\" ng-click=\"pageLastPageClick()\" ng-disabled=\"cantPageToLast()\"><div class=\"last-triangle\"><div class=\"last-bar\"></div></div></button></div><div class=\"ui-grid-pager-row-count-picker\" ng-if=\"grid.options.paginationPageSizes.length > 1\"><select ui-grid-one-bind-aria-labelledby-grid=\"'items-per-page-label'\" ng-model=\"grid.options.paginationPageSize\" ng-options=\"o as o for o in grid.options.paginationPageSizes\"></select><span ui-grid-one-bind-id-grid=\"'items-per-page-label'\" class=\"ui-grid-pager-row-count-label\">&nbsp;{{sizesLabel}}</span></div><span ng-if=\"grid.options.paginationPageSizes.length <= 1\" class=\"ui-grid-pager-row-count-label\">{{grid.options.paginationPageSize}}&nbsp;{{sizesLabel}}</span></div><div class=\"ui-grid-pager-count-container\"><div class=\"ui-grid-pager-count\"><span ng-show=\"grid.options.totalItems > 0\">{{(((grid.options.paginationCurrentPage-1)*grid.options.paginationPageSize)+1)}} <abbr ui-grid-one-bind-title=\"paginationThrough\">-</abbr> {{(grid.options.paginationCurrentPage*grid.options.paginationPageSize>grid.options.totalItems?grid.options.totalItems:grid.options.paginationCurrentPage*grid.options.paginationPageSize)}} {{paginationOf}} {{grid.options.totalItems}} {{totalItemsLabel}}</span></div></div></div>";

  this.gridOptions = {
    language: 'es',
    // i18n: 'es',
    onRegisterApi: (gridApi) => {
      this.gridApi = gridApi;

      this.gridApi.grid.registerRowsProcessor(this.commentsFilter, 200);

      gridApi.pagination.on.paginationChanged($scope, (pageNumber, pageSize) => {
        ConfigService.set(CONSTANTS.PAGE_SIZE, pageSize);
      });
    },
    enableSorting: true,
    enableColumnMenus: false,
    columnDefs: [
      { field: 'actions', displayName: '', enableColumnMenu: false, enableFiltering: false, enableSorting: false, cellClass: 'grid-align-center', cellTemplate: '<div><tsz-report-menu-actions report=row.entity></tsz-report-menu-actions> <!--{{row.entity.id}}--></div>', width: 30 },
      { field: 'name', displayName: 'Sector', cellTooltip: true, cellTemplate: '<div class="ui-grid-cell-contents"><a ng-href="report/{{row.entity.id}}" class="report-link">{{row.entity.name}} <md-icon ng-show="row.entity.downloadable" class="material-icons" style="margin-left: 5px;">picture_as_pdf</md-icon></a><md-tooltip>{{row.entity.name}}</md-tooltip></div>' },
      { field: 'meredicteVersion', displayName: 'Versión', cellFilter: 'version', filter: { type: uiGridConstants.filter.SELECT, selectOptions: this.getVersionOpts() }, width: 100 },
      { field: 'design_type', displayName: 'Diseño', cellFilter: 'designType', filter: { type: uiGridConstants.filter.SELECT, selectOptions: this.getDesignTypeOpts() }, width: 130 },
      { field: 'building_usage', displayName: 'Uso', cellFilter: 'buildingUsage', filter: { type: uiGridConstants.filter.SELECT, selectOptions: this.getBuildingUsageOpts() }, width: 170 },
      { field: 'code', displayName: 'Código', width: 160 },
      { field: 'province', displayName: 'Provincia', width: 120 },
      { field: 'createdAt', displayName: 'Creado', type: 'date', cellFilter: 'date:\'yyyy-MM-dd\'', cellClass: 'grid-align-center', width: 100 },
      { field: 'updatedAt', displayName: 'Actualizado', type: 'date', cellFilter: 'date:\'yyyy-MM-dd\'', cellClass: 'grid-align-center', width: 125, sort: { direction: uiGridConstants.DESC } },
      { field: 'nrg', displayName: 'NRG', visible: this.canSeeCuantitativeResults, enableFiltering: false, cellFilter: 'number:2', width: 72, cellClass: 'grid-align-right' },
    ],
    enableFiltering: false,
    enableHorizontalScrollbar: 0,
    enableVerticalScrollbar: 0,
    paginationPageSizes: [5, 10, 25, 50],
    paginationPageSize: ConfigService.get(CONSTANTS.PAGE_SIZE, 10),
    paginationTemplate: correctTotalPaginationTemplate,
  };

  this.setMinRowsToShow = () => {
    this.gridApi.grid.options.minRowsToShow =
      Math.min(this.gridOptions.data.length, $scope.maxRowToShow);
    this.gridApi.grid.options.virtualizationThreshold = this.gridApi.grid.options.minRowsToShow;
  };

  this.getVisibleRows = () =>
    Math.min(this.gridOptions.data.length, this.gridApi.grid.options.paginationPageSizes[0]);

  this.toggleFiltering = () => {
    console.log('Toggle filtering');
    this.gridOptions.enableFiltering = !this.gridOptions.enableFiltering;
    this.gridApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
  };

  this.onCommentsFilterChange = (filterValue) => {
    this.filterValue = filterValue;
    this.gridApi.grid.refresh();
  };

  this.commentsFilter = (renderableRows) => {
    if (this.filterValue) {
      const matcher = new RegExp(this.removeAccents(this.filterValue), 'i');
      renderableRows.forEach((row) => {
        let match = false;
        ['name', 'comments'].forEach((field) => {
          if (row.entity[field] && this.removeAccents(row.entity[field]).match(matcher)) {
            match = true;
          }
        });
        if (!match) {
          row.visible = false;
        }
      });
    }
    return renderableRows;
  };

  this.removeAccents = (s) => (s !== null ? s.toLowerCase()
      .replace(new RegExp(/[àáâãäå]/g), 'a')
      .replace(new RegExp(/[èéêë]/g), 'e')
      .replace(new RegExp(/[ìíîï]/g), 'i')
      .replace(new RegExp(/ñ/g), 'n')
      .replace(new RegExp(/[òóôõö]/g), 'o')
      .replace(new RegExp(/[ùúûü]/g), 'u') : s);

  this.loadReports = () => {
    ReportService.list()
    .then((result) => {
      this.gridOptions.data = result;
      this.gridheight = (result.lenght + 1) * 30;
    }).catch((err) => {
      console.log(err);
    });
  };

  this.gotoCreateReport = (ev) => {
    const confirm = $mdDialog.confirm()
      .title('Nuevo proyecto')
      .textContent('Seleccione la versión de MEREDICTE© que desea utilizar (la versión 2.0 es la actualización según el Real Decreto 732/2019 que se adapta a la versión actualmente vigente del DBSI).')
      .ariaLabel('Selecciona la versión de MEREDICTE© a utilizar.')
      .targetEvent(ev)
      .ok('MEREDICTE© 2.0')
      .cancel('MEREDICTE© 1.0');

    $mdDialog.show(confirm).then(() => {
      $state.go('report', { v: 'V2' });
    }, () => {
      $state.go('report', { v: 'V1' });
    });
  };

  this.verifyCsv = (csv) => {
    ReportService.verify_csv(csv)
    .then((response) => {

      const creationDate = $filter('date')(response.creationDate, 'yyyy-MM-dd');

      $mdDialog.show(
        $mdDialog.alert()
          .clickOutsideToClose(true)
          .title(response.name)
          .textContent(`Creado el: ${creationDate}`)
          .ariaLabel('Alert Dialog Demo')
          .ok('Ok!')
      );
    }).catch(() => {
      $mdDialog.show(
        $mdDialog.alert()
          .clickOutsideToClose(true)
          .title('CSV erróneo')
          .textContent('No se ha encontrado ningún proyecto con el CSV especificado')
          .ok('Ok!')
      );
    });
  };

  $scope.$on('report_deleted', () => {
    this.loadReports();
  });

  $scope.$on('report_duplicated', (event, data) => {
    $tszToast.showSuccess(`Proyecto "${data.name}" generado correctamente`);
    this.loadReports();
  });

  this.loadReports();
}

export default {
  template,
  controller: homeComponent,
};



// WEBPACK FOOTER //
// ./src/containers/home/index.js